'use client';

import { cn } from '@coas/ui/lib';
import { sexSchema } from '@coas/validators/const';
import { useAtom } from 'jotai';
import Link from 'next/link';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import { api } from 'trpc/react';
import Icon20LogoInstagramOutline from '~/shared/assets/icons/20-logo-instagram-outline.svg';
import Icon20LogoTelegram from '~/shared/assets/icons/20-logo-telegram.svg';
import Icon20LogoVkOutline from '~/shared/assets/icons/20-logo-vk-outline.svg';
import IconClose from '~/shared/assets/icons/close.svg';
import { sidebarStateAtom } from '../model/state';
import { CategoryLink, CategoryLinkSkeleton } from './CategoryLink';
import { SexLink } from './SexLink';
import styles from './Sidebar.module.scss';

export default () => {
    const [{ open, sex }, setState] = useAtom(sidebarStateAtom);

    const { isLoading, isSuccess, data } = api.category.getAll.useQuery([sex]);

    return (
        <ModalOverlay
            className={styles.modalOverlay}
            isOpen={open}
            onOpenChange={() => setState(prev => ({ ...prev, open: false }))}
            isDismissable
        >
            <Modal className={styles.modal}>
                <Dialog className={'min-h-screen w-full bg-neutral-50 text-neutral-950 '}>
                    <div
                        className={
                            'flex max-h-screen min-h-screen w-full flex-col gap-y-page overflow-auto p-page pt-0'
                        }
                    >
                        <div
                            className={
                                'sticky top-0 z-50 flex w-full items-center justify-center bg-neutral-50 pt-page'
                            }
                        >
                            <SexLink sex={sexSchema.enum.woman}>Женщины</SexLink>
                            <SexLink sex={sexSchema.enum.man}>Мужчины</SexLink>
                            <button
                                type='button'
                                className={'ml-3 rounded-14 bg-neutral-200 p-2'}
                                onClick={() => setState(prev => ({ ...prev, open: false }))}
                            >
                                <IconClose className={'h-5 w-5 stroke-neutral-500'} />
                            </button>
                        </div>
                        <nav className={'flex flex-col gap-y-5'}>
                            {isLoading &&
                                Array.from({ length: 8 }).map((_, index) => <CategoryLinkSkeleton key={index} />)}
                            {isSuccess &&
                                data.items.map(category => <CategoryLink key={category.id} category={category} />)}
                        </nav>
                        <div className={'flex-1'} />
                        <div
                            className={cn(
                                'flex flex-col items-start',
                                'child:inline-flex child:items-center child:gap-x-1 child:py-1 child:text-neutral-600',
                            )}
                        >
                            <a href={'https://t.me/coasworld'} target={'_blank'} rel='noreferrer'>
                                <Icon20LogoTelegram className={'mb-1 size-4'} />
                                Telegram
                            </a>
                            <a
                                href={'https://www.instagram.com/coasworld?igsh=MXFkbXBobWthaDdwdw=='}
                                target={'_blank'}
                                rel='noreferrer'
                            >
                                <Icon20LogoInstagramOutline className={'mb-1 size-4'} />
                                Instagram
                            </a>
                            <a href={'https://vk.com/coasworld'} target={'_blank'} rel='noreferrer'>
                                <Icon20LogoVkOutline className={'mb-1 size-4'} />
                                VKontakte
                            </a>
                            <div />
                            <Link href={'/docs/offer.pdf'} target={'_blank'}>
                                Договор оферты
                            </Link>
                            <Link href={'/docs/personal.pdf'} target={'_blank'}>
                                Политика конфиденциальности
                            </Link>
                            <div />
                        </div>
                    </div>
                </Dialog>
            </Modal>
        </ModalOverlay>
    );
};
